const en = {
  common: {
    home: "Home",
    shop: "Shop",
    myOrders: "Purchases",
    cart: "Cart",
    logout: "Logout",
    loading: "Loading...",
    all: "All",
    you: "You",
    price: "Price",
    subtotal: "Subtotal",
    discount: "Discount",
    total: "Total",
    action: "Action",
    photos: "Photos",
    fullscreen: "Fullscreen",
    clickToExpand: "Click to enlarge",
    backToTop: "Back to top",
    back: "Back",
    support: "Support",
    error: "Error",
  },
  home: {
    title: "Welcome to my",
    marketplace: "Marketplace",
    subtitle: "A place created especially for you to collect your best volleyball memories.",
    goToShop: "Go to store",
  },
  shop: {
    greeting: "Hello, {name}",
    defaultAthleteName: "Athlete",
    photoGallery: "Photo Gallery",
    upToDiscount: "Up to {percent}% off",
    discountApplied: "Disc.: {percent}%",
    searchLabel: "Search by athlete, tags, or location",
    searchPlaceholder: "E.g.: athlete name, team, final etc.",
    clearSearch: "Clear search",
    noPhotosFound: "No photos found",
    discountTag: "Disc",
    wantPhoto: "Add",
    wantThisPhoto: "I want this photo",
    removeFromCart: "Remove from cart",
    buyPhotos: "Buy photos",
    fitMode: "⊡ Fit",
    panoramicMode: "↔ Panoramic",
    photoCounter: "{current} of {total}",
  },
  cart: {
    title: "Your Cart",
    emptyMessage: "Your cart is empty.",
    goToShop: "Go to store",
    clearCart: "Clear cart",
    minPhotosWarning: "Please select at least {min} photo{plural} to proceed with checkout.",
    proceedToPayment: "Proceed to payment",
    photosHeader: "Photos",
    valueHeader: "Price",
    actionHeader: "Action",
    removeBtn: "Remove",
    cartFloating: "Cart",
  },
  payment: {
    infoTitle: "Payment Information",
    totalPhotos: "Total photos:",
    purchasedAt: "Order date:",
    subtotal: "Subtotal",
    discount: "Discount",
    total: "Total",
    pixCopyPaste: "PIX Copy & Paste",
    copyPixKey: "Copy PIX code",
    generateAgain: "Generate again",
    status: "Status:",
    statusPending: "Pending",
    statusInReview: "Payment in review",
    statusPaid: "Paid",
    instructionsTitle: "Payment Instructions:",
    instruction1: "1. Open your banking app and go to the PIX area",
    instruction2: "2. Look for 'PIX Copia e Cola' (Copy & Paste)",
    instruction3: "3. Paste the code, confirm details and complete payment.",
    customPaymentNote: "Notice for international customers: PIX is Brazil's instant payment system. If you do not hold a Brazilian bank account, please contact us for alternative payment options (credit card or international transfer).",
    itemsPurchasedTitle: "Purchased Items",
    downloadBtn: "Download",
    loadingItems: "Loading purchased items...",
    reloadHint: "If it takes too long, please refresh the page.",
    copiedSuccess: "PIX code copied to clipboard",
    copyFail: "Could not copy automatically",
    generatingPix: "Generating PIX code...",
  },
  orders: {
    title: "My Purchases",
    noOrders: "You have not made any purchases yet.",
    errorLoading: "Error loading purchases.",
    dateTime: "Date/Time",
    quantity: "Qty",
    value: "Price",
    status: "Status",
    details: "Details",
  },
  phoneModal: {
    title: "Receive updates via WhatsApp",
    approvalNotice: "⏱️ Approval within up to 4 hours",
    approvalDescription: "Payment approval can take up to 4 hours. Enter your WhatsApp to be notified instantly",
    phonePlaceholder: "Enter your phone number",
    save: "Save and Continue",
    saving: "Saving...",
    later: "Not now",
  },
  auth: {
    welcome: "Welcome, {name}!",
    storeAccess: "Store Access",
    restrictedAreaAlert: "This area is restricted to athletes and managers.",
    accessCode: "Access code",
    enter: "Sign in",
    noCodeWhatsapp: "Don't have a code yet? Just message me on WhatsApp:",
    whatsappMessage: "Hi, Adauto. I need an access code.",
    authenticating: "Authenticating access...",
  },
};

export default en;